import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  filterPaper: {
    maxHeight: 76,
    overflowY: 'auto',
  },
  filterBtn: {
    '&:hover': {
      borderColor: '#000000',
    },
    borderColor: '#000000',
    color: '#000000',
  },
  siteChip: {
    backgroundColor: theme.palette.warning.main,
  },
  extensionChip: {
    backgroundColor: 'rgb(0, 160, 255)',
  },
  extensionName: {
    backgroundColor: '#43a047',
  },
  excludeAllRules: {
    backgroundColor: '#8d6e63',
  },
  excludeRulesChecked: {
    backgroundColor: '#78909c',
  },
  range: {
    backgroundColor: 'rgb(160,32,240)',
  },
  addIcon: {
    fontSize: '26px !important',
  },
}));
